// extracted by mini-css-extract-plugin
export default {"container":"social_container__2ewFl","item":"social_item__1milO","icon":"social_icon__1WY8L","inner":"social_inner__16dX1","padded":"social_padded__13yrN"};